import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 200 200",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 43,
				cy: 157.1,
				r: 30.4,
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 100,
				cy: 100,
				r: 30.5,
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				transform: "matrix(0.1602 -0.9871 0.9871 0.1602 89.498 191.0923)",
				cx: 157.1,
				cy: 43,
				rx: 30.5,
				ry: 30.4,
				fill: "currentColor"
			})
		] }) }),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {})
	]
});
export { SvgIconOdd as ReactComponent };
